import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const AcademicBackBtn = () => {
    return (
        <a className="text-decoration-none" href="/#Academic">
        <h5 className="section-title pinter-cursor  pb-4" >
            <FontAwesomeIcon icon={faChevronLeft} className="back-btn " />  Academic Initiatives
      </h5>
    </a>
    );
};

export default AcademicBackBtn;